import React from 'react';
import './app-chat-message.css';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AppChatPerson from '../app-chat/app-chat-person.jsx';
import * as DOMPurify from 'dompurify';
import File from '../../components/File/File';
import OptionsMenu from '../../components/shared/OptionsMenu/OptionsMenu';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

export class AppChatMessage extends React.Component {
  element;
  hasMarkedAsRead = false;

  files = this.props.files;
  name = this.props.name;
  type = this.props.type;
  date = this.props.date;
  message = this.props.message;
  email = this.props.email;
  phone = this.props.phone;
  read = this.props.read;
  newMessage = this.props.newMessage;

  getLocalDateTime(givenDate) {
    const utcDate = givenDate.toString();
    const gmtDateTime = moment.utc(utcDate);
    const local = gmtDateTime.local().format('YYYY-MMM-DD h:mm A');
    return moment(local, 'YYYY-MMM-DD h:mm A').format('llll');
  }

  handleMarkUnread = () => {
    if (this.props.onMarkUnread && this.props.messageId) {
      this.props.onMarkUnread(this.props.messageId);
      this.hasMarkedAsRead = false;
    }
  };

  handleMouseEnter = () => {
    if (this.props.isUnread && !this.hasMarkedAsRead && this.props.onMarkRead && this.props.messageId) {
      this.hasMarkedAsRead = true;
      this.props.onMarkRead(this.props.messageId);
    }
  };

  getMenuOptions() {
    const options = [];
    if (this.props.onMarkUnread) {
      options.push({
        label: this.props.markUnreadLabel,
        action: this.handleMarkUnread,
        icon: <MailOutlineIcon style={{ width: '16px', height: '16px', marginRight: '8px' }} />,
        key: 'mark-unread'
      });
    }
    
    return options;
  }

  render() {
    if (!this.props.files) {
      this.props.files = [];
    }
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(this.props.message);
    const menuOptions = this.getMenuOptions();
    const showUnreadDot = this.props.isUnread;
    
    return (
      <div
        className={`app-chat-message
                message
                person-${this.props.type}
                ${this.props.newMessage ? 'new-message' : ''}
                ${showUnreadDot ? 'is-unread' : ''}
                `}
        onMouseEnter={this.handleMouseEnter}
      >
        <div className="overflow">
          <div className="wrapper">
            <div className="head">
              <div className="head-left">
                <AppChatPerson
                  name={this.props.name}
                  avatar={this.props.avatarUrl}
                  showUnreadDot={showUnreadDot}
                  {...this.props}
                />
              </div>
              <div className="head-right">
                <div className="info">
                  <span className="date">
                    {moment(this.props.date).format('YYYY-MM-DD HH:mm')}
                  </span>
                </div>
                {menuOptions.length > 0 && (
                  <div className="message-options-menu">
                    <OptionsMenu options={menuOptions} />
                  </div>
                )}
              </div>
            </div>
            <div className="body">
              <span
                className={!isHtml ? 'style--message-chat' : ''}
                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.props.message)}}
                style={{ marginBottom: '10px' }}
              >

              </span>
              <div className="uploaded-files" style={{ display: 'flex', 'flexWrap': 'wrap', gap: '10px' }}>
                {!_.isEmpty(this.props.files) &&
                  this.props.files.map((item, key) => {
                    return (
                      <File
                        key={key}
                        fileName={item.fileName || item.file}
                        file={item.file}
                        scope={this.props.scope}
                        scopeOptions={this.props.scopeOptions}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
